import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.scss';

export default class Card extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    className: PropTypes.string,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  render() {
    return (
      <div
        className={classNames(
          'Card',
          {'Card--visible': !this.props.loading},
          {[`${this.props.className}`]: this.props.className},
        )}>
        {this.props.children}
      </div>
    );
  }
}
